// extracted by mini-css-extract-plugin
module.exports = {"Logo__image":"Logo_Logo__image__l6hyw","fadeInKeyframe":"Logo_fadeInKeyframe__Cu46b"};